// extracted by mini-css-extract-plugin
module.exports = {"footer-bottom":"FooterBottom_footer-bottom__sFGWG"};